import { ChangeDetectionStrategy, Component, Injector, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * PropertyDetails Widget
 */
@Component({
  selector: 'property-details-widget',
  templateUrl: './property-details-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './property-details-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertyDetailsWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'propertyDetails', true);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useReadOnlySaveChangesHandler();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('propertydetails');

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('propertydetails', this.getReport());
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }
}
